import React from "react";

export default function Layout({ children, currentPageName }) {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@300;400;500;600;700&display=swap');
        
        body, html, #root, .font-sans { /* Target common elements and Tailwind's default sans-serif class */
          font-family: 'Noto Sans Hebrew', sans-serif !important;
        }

        /* Fix for ShadCN UI input focus outline when using custom font */
        .focus-visible\\:ring-ring:focus-visible {
            outline: 2px solid hsl(var(--ring)) !important;
            outline-offset: 2px !important;
        }
        input:focus, textarea:focus, select:focus, button:focus {
          outline-color: hsl(var(--ring)) !important;
        }
        /* Ensure date picker also uses the font */
        .rdp {
           font-family: 'Noto Sans Hebrew', sans-serif !important;
        }
      `}</style>
      <div className="font-sans">{children}</div>
    </>
  );
}
